import Vue from 'vue'
const vm = Vue.prototype

export const actions={}
